<template>
    <el-row>
        <div class="header">
            <b>Bin number: {{ binNumber }}</b>
        </div>
        <el-row type="flex" justify="center">
            <el-col :span="18">
            <div class="tag-grid">
                <button @click="onTagSelected(tag)" class="el-tag" :class="{ 'el-tag-selected': isTagSelected(tag) }" v-for="tag in tags" :key="tag.id">
                    <b>{{ tag.name }}</b>
                </button>
            </div>
            </el-col>
        </el-row>
        <el-row type="flex" justify="space-around" :gutter="9" class="container">
            <el-col :span="12" class="text-left">
                <router-link to="/bin_number">
                    <el-button type="default">
                        Back
                    </el-button>
                </router-link>
            </el-col>
            <el-col :span="12" class="text-right">
                <router-link to="/home">
                    <el-button type="default">
                        Next
                    </el-button>
                </router-link>
            </el-col>
        </el-row>
    </el-row>
</template>
  
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'TagsPage',
    computed: {
        binNumber() {
            return this.$store.getters['shopper/selectedBinNumber'];
        },
        tags() {
            return this.$store.getters['tags/getTags'].filter((tag) => !tag.hidden);
        },
    },
    methods: {
        onTagSelected(tag) {
            // add tags to selected tags or remove tags from selected tags
            let selectedTagIds = this.$store.getters['tags/getSelectedTags'].map((tag) => tag.id);
            if (selectedTagIds.includes(tag.id)) {
                this.$store.dispatch('tags/removeSelectedTag', tag);
            } else {
                this.$store.dispatch('tags/addSelectedTag', tag);
            }
        },
        isTagSelected(tag) {
            return this.$store.getters['tags/getSelectedTags'].map((tag) => tag.id).includes(tag.id);
        }
    },
};
</script>

<style scoped>
.tag-grid {
  display: grid;
  grid-template-columns: repeat(3, 2fr); /* Two columns of equal width */
  gap: 10px; /* Adjust gap between tags */
  aspect-ratio: 3/1; /* Make the grid a square */
  margin-bottom: 20px;
}

.el-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e6e9f0;
  border-radius: 7.5px;
  font-size: 18px;
  color: #04246a;
  height: 100%;
  cursor: pointer;
}

.el-tag-selected {
  border: 2px solid #409eff;
}

.container {
  padding: 0 22vw 0 22vw;
  text-transform: capitalize;
}

.header {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: -20px;
  text-align: center;
}
</style>